<div class="popup confirmSimulationLaunchPopup">
    <div *ngIf="simulationStatus === 'NOT_STARTED'" class="confirmSimulationLaunchPopup-img"></div>

    <h1 class="confirmSimulationLaunchPopup-title _primary">
        <span [i18nKey]="'simulation.launch.simulation.of.period'"></span>

        <p class="periodInfo">
            <kiwi-period [period]="period"></kiwi-period>
        </p>
    </h1>

    <ng-container *ngIf="simulationStatus === 'NOT_STARTED'">
        <p class="confirmSimulationLaunchPopup-message">
            <span [i18nKey]="'simulation.launch.popup.message1'"></span>
            <strong>
                <kiwi-period [period]="period"></kiwi-period>
            </strong>

            <span [i18nKey]="'simulation.launch.popup.message4'"></span>
        </p>

        <div class="grid-x grid-margin-x align-center confirmSimulationLaunchPopup-action">
            <button (click)="cancel()" class="cell shrink button _cancel">{{cancelButtonMessage}}</button>
            <button (click)="confirm()" class="cell shrink button" [i18nKey]="confirmButtonMessage"></button>
        </div>
    </ng-container>
</div>
<div class="overlay"></div>
